(function() {
    'use strict';

    angular
        .module('elogbooks')
        .config(Translations);

    function Translations($translateProvider) {
        $translateProvider.translations('nl', {

            LEGEND_JOB_REACTIVE_OVERDUE_STATUTORY_ATTENDANCE: 'Wettelijk verplicht niet op tijd',
            LEGEND_JOB_REACTIVE_OVERDUE_NON_STATUTORY_ATTENDANCE: 'Niet wettelijk verplicht niet op tijd',
            LEGEND_JOB_REACTIVE_NOT_OVERDUE_ATTENDANCE: 'Open',

            LEGEND_JOB_PLANNED_OVERDUE_STATUTORY_COMPLETION: 'Wettelijk verplicht niet op tijd',
            LEGEND_JOB_PLANNED_OVERDUE_NON_STATUTORY_COMPLETION: 'Niet wettelijk verplicht niet op tijd',
            LEGEND_JOB_PLANNED_OVERDUE_COMPLETION: 'Niet op tijd',
            LEGEND_JOB_PLANNED_NOT_OVERDUE_COMPLETION: 'Open',

            LEGEND_ACTION_OPEN: 'Open',
            LEGEND_ACTION_COMPLETED: 'Afgerond'

        });
    }
})();
